import MobileHomePageLayout from '../../layout/Mobile/MobileHomePageLayout'
import MobileMainLayout from '../../layout/Mobile/MobileMainLayout'

const MobileHomePage = () => {
  return (
    <>
      <MobileMainLayout>
        <MobileHomePageLayout />
      </MobileMainLayout>
    </>
  )
}

export default MobileHomePage
